import { Fragment, useState } from "react";

import dynamic from "next/dynamic";

import PropTypes from "prop-types";

import { AutoConvertPriceWithUnit } from "common/priceConvert";

import { FaCheck } from "components/atoms/Icon/fa/FaCheck";
import Img from "components/atoms/Img";
import TawkToButton from "components/atoms/TawkToButton/index";
import Toast from "components/atoms/Toast/index";
import FormDownloadModal from "components/templates/common/post/FormDownloadModal";
const PackageModal = dynamic(
  () => import("components/molecules/PackageModal"),
  {
    ssr: false,
  }
);

import styles from "./Index.module.scss";
/** ========== */

const CardPackage = ({
  kind,
  price,
  changePrice,
  data,
  dataSuffix,
  index,
  linkRegister,
  subPrice,
  sale_off,
  pauseRegister,
  customCardColor,
}) => {
  const getKindClass = () => {
    if (customCardColor) {
      if (index == 0) return customCardColor.text[0];
      if (index == 1) return customCardColor.text[1];
      if (index == 2) return customCardColor.text[2];
    } else {
      if (index == 0) return "text-bbc-brand-500";
      if (index == 1) return "text-bbc-yellow-500";
      if (index == 2) return "text-bbc-brand-700";
    }
  };

  const borderColorClass = () => {
    if (customCardColor) {
      if (index == 0) return customCardColor.border[0];
      if (index == 1) return customCardColor.border[1];
      if (index == 2) return customCardColor.border[2];
    } else {
      if (index == 0) return "lg:hover:border-bbc-brand-500";
      if (index == 1) return "lg:hover:border-bbc-yellow-500";
      if (index == 2) return "lg:hover:border-bbc-brand-700";
    }
  };

  const btnColorClass = () => {
    if (customCardColor) {
      if (index == 0) return customCardColor.button[0];
      if (index == 1) return customCardColor.button[1];
      if (index == 2) return customCardColor.button[2];
    } else {
      if (index == 0) return `bg-bbc-brand-500  ${styles.btnBlue} `;
      if (index == 1) return `bg-bbc-yellow-500  ${styles.btnYellow}`;
      if (index == 2) return `bg-bbc-brand-700 ${styles.btnDarkBlue}`;
    }
  };

  const {
    content,
    notes,
    banner,
    bannerLink,
    banner_width,
    banner_height,
    dataForm,
  } = data || [];
  const [modalShow, setModalShow] = useState(false);
  const [showFormDownload, setShowFormDownload] = useState(false);

  const showEbookBookModal = () => {
    setShowFormDownload(true);
  };

  const GetPrice = ({ priceConvert, unitChange }) => {
    return (
      <>
        {changePrice ? (
          <>{AutoConvertPriceWithUnit(priceConvert, unitChange || 1)}</>
        ) : (
          <>
            <span>{unitChange || "US$"}</span>
            {priceConvert}
          </>
        )}
      </>
    );
  };

  return (
    <div
      style={{ maxWidth: "350px" }}
      className={`${borderColorClass()} group relative m-auto flex h-full flex-col justify-between rounded-3xl  border-0 border-transparent bg-white ring-1 ring-neutral-200 transition-all duration-200 hover:ring-transparent lg:border-4 lg:hover:border-4 lg:hover:shadow-[0px_16px_40px_rgba(181,181,181,0.25)]`}
    >
      <div
        style={{ zIndex: "2", backgroundColor: "white", borderRadius: "24px" }}
      >
        <div
          style={{ paddingTop: "29px" }}
          className={`border-b border-b-bbc-neutral-500 px-5  pb-8 text-center ${getKindClass(
            index
          )}`}
        >
          <p
            style={{
              fontSize: "32px",
              lineHeight: "42px",
              letterSpacing: "0.25px",
            }}
            className="mb-8 font-semibold uppercase"
          >
            {kind}
          </p>
          <div
            style={{
              fontSize: "50px",
              lineHeight: "54px",
              letterSpacing: "0.25px",
            }}
            className="flex items-center justify-center font-semibold lg:flex-wrap xl:flex-nowrap"
          >
            <div className={`${subPrice && "mr-2"} inline-block`}>
              <GetPrice priceConvert={price} />
            </div>
            {subPrice && (
              <div
                className="inline-block text-2xl font-semibold text-bbc-brand-900"
                dangerouslySetInnerHTML={{ __html: subPrice }}
              />
            )}
          </div>
          {sale_off && (
            <div className="mt-2 text-2xl font-medium text-bbc-neutral-700">
              Save <GetPrice priceConvert={sale_off} />
            </div>
          )}
        </div>
        <div className="py-8 px-5">
          {content?.length > 0 &&
            content.map((item, index) => (
              <Fragment key={index}>
                {item.preTitle && (
                  <div
                    className="relative mt-2 flex font-semibold first:mt-0"
                    dangerouslySetInnerHTML={{ __html: item.preTitle }}
                  />
                )}
                {item.subTitle && (
                  <div
                    className="relative mt-2 flex pl-4 font-semibold before:absolute before:top-2 before:left-0 before:inline-block before:h-2 before:w-2 before:rounded-full before:bg-bbc-brand-500 before:content-[''] first:mt-0"
                    dangerouslySetInnerHTML={{ __html: item.subTitle }}
                  />
                )}
                {item?.description && (
                  <div
                    className="mt-2"
                    dangerouslySetInnerHTML={{ __html: item.description }}
                  ></div>
                )}
                {item?.listContent && item?.listContent.length > 0 && (
                  <ul className="pl-0.5">
                    {item.listContent.map((content, key) =>
                      content.checkName || content.ebook_download ? (
                        <div key={key}>
                          {content.checkName && (
                            <Fragment>
                              <Toast>
                                {modalShow && (
                                  <PackageModal
                                    country_name={dataSuffix.name}
                                    country_id={dataSuffix.id}
                                    show={modalShow}
                                    onHide={() => setModalShow(false)}
                                    suffix_data={dataSuffix.suffixData}
                                  />
                                )}
                              </Toast>
                            </Fragment>
                          )}
                          {/* {content.ebook_download && (
                            <Fragment>
                              <Toast>
                                <EbookModal
                                  show={ebookModalShow}
                                  onHide={() => setEbookModalShow(false)}
                                  imgLeft={content.img_left_src || ""}
                                  triggerName={content.trigger_name || ""}
                                  apiLink={content.api_link || ""}
                                  contactFromId={
                                    content.contact_from_id || null
                                  }
                                />
                              </Toast>
                            </Fragment>
                          )} */}
                          {content.ebook_download && (
                            <FormDownloadModal
                              show={showFormDownload}
                              onHide={() => setShowFormDownload(false)}
                              typeFormDownload="checklist_delaware"
                            />
                          )}
                          {content.dataForm ? (
                            <li
                              key={key}
                              className="relative mt-2 cursor-pointer"
                              onClick={() => {
                                content.checkName
                                  ? setModalShow(true)
                                  : content.ebook_download &&
                                    setShowFormDownload(true);
                              }}
                            >
                              <FaCheck
                                className="absolute top-1.5 left-0 text-bbc-brand-500"
                                size={12}
                              />
                              <button
                                className="btn inline-block pl-7 font-medium text-bbc-primary "
                                dangerouslySetInnerHTML={{
                                  __html: content.text,
                                }}
                              ></button>
                              {content.childContent &&
                                content.childContent.map((item1, index1) => {
                                  return (
                                    <li key={index1}>
                                      <span
                                        className="inline-block pl-7 font-medium text-bbc-primary"
                                        dangerouslySetInnerHTML={{
                                          __html: item1,
                                        }}
                                      ></span>
                                    </li>
                                  );
                                })}
                            </li>
                          ) : (
                            <li
                              key={key}
                              className="relative mt-2 cursor-pointer"
                              id={content.hash_id && content.hash_id}
                              onClick={() => {
                                content.checkName
                                  ? setModalShow(true)
                                  : content.ebook_download &&
                                    showEbookBookModal(content.hash_id);
                              }}
                            >
                              <FaCheck
                                className="absolute top-1.5 left-0 text-bbc-brand-500"
                                size={12}
                              />
                              <span
                                className="inline-block pl-7 font-medium text-bbc-primary "
                                dangerouslySetInnerHTML={{
                                  __html: content.text,
                                }}
                              ></span>
                              {content.childContent &&
                                content.childContent.map((item1, index1) => {
                                  return (
                                    <li key={index1}>
                                      <span
                                        className="inline-block pl-7 font-medium text-bbc-primary"
                                        dangerouslySetInnerHTML={{
                                          __html: item1,
                                        }}
                                      ></span>
                                    </li>
                                  );
                                })}
                            </li>
                          )}
                        </div>
                      ) : (
                        <li className="relative mt-2" key={key}>
                          <FaCheck
                            className="absolute top-1.5 left-0 text-bbc-brand-500"
                            size={12}
                          />
                          <span
                            className="inline-block pl-7"
                            dangerouslySetInnerHTML={{ __html: content.text }}
                          ></span>
                          {content.childContent &&
                            content.childContent.map((item1, index1) => {
                              return (
                                <li key={index1} className="ml-12 list-disc ">
                                  <span
                                    dangerouslySetInnerHTML={{
                                      __html: item1,
                                    }}
                                  ></span>
                                </li>
                              );
                            })}
                        </li>
                      )
                    )}
                  </ul>
                )}
              </Fragment>
            ))}
          {notes?.length > 0 &&
            notes.map((item, index) => (
              <em
                className="mt-2 block text-sm leading-6"
                key={index}
                dangerouslySetInnerHTML={{ __html: item }}
              ></em>
            ))}
          {banner &&
            (bannerLink && bannerLink.length > 0 ? (
              <>
                {dataForm ? (
                  <div
                    id="shortcode_download_form"
                    className="mt-10 rounded-xl bg-bbc-brand-800 px-5 pt-4"
                  >
                    <p className="pb-2 text-center font-semibold text-bbc-white">
                      Not sure which banks suit you? Try our all-inclusive
                      banking guideline!
                    </p>

                    <div className="relative pt-4">
                      <Img
                        className="mx-auto  h-auto w-fit cursor-pointer"
                        src={
                          "/assets/images/offshore/country/delaware/ebook_redirect-delaware-book.png"
                        }
                        alt="package banner"
                        width={788}
                        height={763}
                        wrapper={{ className: "w-full " }}
                      />
                      <div className="absolute top-0 w-full text-center">
                        <button
                          onClick={() => setShowFormDownload(true)}
                          className="pl-3"
                        >
                          <Img
                            className=" h-auto w-fit cursor-pointer transition-transform duration-150 hover:scale-105"
                            src={
                              "/assets/images/offshore/country/delaware/ebook_redirect-delaware-download-btn.png"
                            }
                            alt="package banner"
                            width={186}
                            height={77}
                          />
                        </button>
                      </div>
                    </div>
                    {dataForm && (
                      <FormDownloadModal
                        show={showFormDownload}
                        onHide={() => setShowFormDownload(false)}
                        typeFormDownload="banking_guide"
                      />
                    )}
                  </div>
                ) : (
                  <a href={bannerLink} rel="nofollow">
                    <Img
                      className="mx-auto mt-6 h-auto w-fit cursor-pointer"
                      src={banner}
                      alt="package banner"
                      width={banner_width || 300}
                      height={banner_height || 192}
                      wrapper={{ className: "w-full " }}
                    />
                  </a>
                )}
              </>
            ) : (
              <Img
                className="mx-auto mt-6 h-auto w-fit"
                src={banner}
                alt="package banner"
                width={banner_width || 300}
                height={banner_height || 192}
                wrapper={{ className: "w-full " }}
              />
            ))}
        </div>
      </div>

      <div className="border-t border-t-bbc-neutral-500 px-5 pt-8 pb-11 text-center">
        {pauseRegister ? (
          // <LinkRouter
          //   Href={"/contact-us"}
          //   ClassName="inline-block w-full cursor-pointer rounded-full border py-2 px-6 font-normal text-bbc-brand-500 hover:bg-bbc-brand-600 group-hover:bg-bbc-brand-500 group-hover:!font-medium group-hover:text-white"
          // >
          //   Contact Us
          // </LinkRouter>
          <TawkToButton
            className={`inline-block w-full cursor-pointer rounded-full  py-2 px-6 font-medium text-bbc-white ${
              styles.btnAnimate
            } ${btnColorClass()} `}
          >
            <span>Chat With Us</span>
          </TawkToButton>
        ) : (
          <a
            href={linkRegister}
            className={`inline-block w-full cursor-pointer rounded-full  py-2 px-6 font-medium text-bbc-white ${
              styles.btnAnimate
            } ${btnColorClass()} `}
          >
            <span>Get Started</span>
          </a>
        )}
      </div>
    </div>
  );
};

export default CardPackage;

CardPackage.propTypes = {
  notes: PropTypes.array,
  content: PropTypes.array,
  index: PropTypes.number,
};

CardPackage.defaultProps = {
  notes: [],
  content: [],
  index: 0,
};

/** ========== */
